import { BrushBlob } from './ui.jsx';

/* ---------- Organic-clipped photo frame ---------- */
let _orgIdx = 0;
const ORGANIC_PATHS = [
  'M60,8 C100,4 160,16 184,52 C208,90 196,150 152,180 C108,210 40,196 20,150 C0,104 14,18 60,8 Z',
  'M30,40 C50,8 130,2 170,30 C210,58 210,150 168,180 C126,210 50,200 24,160 C-2,120 10,72 30,40 Z',
  'M50,12 C100,0 180,22 188,80 C196,138 160,194 100,196 C40,198 8,150 12,90 C16,42 30,18 50,12 Z',
  'M40,30 C80,5 150,8 182,50 C214,92 186,170 130,188 C74,206 18,170 14,120 C10,70 22,50 40,30 Z'
];

if (typeof document !== 'undefined' && !document.getElementById('organic-clip-defs')) {
  const svgNs = 'http://www.w3.org/2000/svg';
  const svg = document.createElementNS(svgNs, 'svg');
  svg.setAttribute('id', 'organic-clip-defs');
  svg.setAttribute('width', '0');
  svg.setAttribute('height', '0');
  svg.style.position = 'absolute';
  svg.style.width = '0';
  svg.style.height = '0';

  const defs = document.createElementNS(svgNs, 'defs');
  ORGANIC_PATHS.forEach((d, i) => {
    const cp = document.createElementNS(svgNs, 'clipPath');
    cp.setAttribute('id', 'organic-clip-' + i);
    cp.setAttribute('clipPathUnits', 'objectBoundingBox');

    const p = document.createElementNS(svgNs, 'path');
    p.setAttribute('d', d);
    p.setAttribute('transform', 'scale(0.005)');
    cp.appendChild(p);
    defs.appendChild(cp);
  });

  svg.appendChild(defs);
  document.body.appendChild(svg);
}

export const OrganicPhoto = ({ src, alt, label, ratio = '4/5', variant, style, paintColor }) => {
  const [errored, setErrored] = useState(false);
  const idx = variant !== undefined ? variant % ORGANIC_PATHS.length : (_orgIdx++ % ORGANIC_PATHS.length);
  const paintIdx = (idx + 1) % ORGANIC_PATHS.length;

  return (
    <div style={{ position: 'relative', aspectRatio: ratio, ...style }}>
      {paintColor && (
        <div
          style={{
            position: 'absolute',
            inset: 0,
            transform: 'translate(10px, 14px) rotate(-2deg)',
            clipPath: `url(#organic-clip-${paintIdx})`,
            WebkitClipPath: `url(#organic-clip-${paintIdx})`,
            background: paintColor,
            opacity: 0.85,
            zIndex: 0
          }}
        />
      )}

      <div
        style={{
          position: 'absolute',
          inset: 0,
          clipPath: `url(#organic-clip-${idx})`,
          WebkitClipPath: `url(#organic-clip-${idx})`,
          background: 'var(--paper-3)',
          zIndex: 1,
          overflow: 'hidden'
        }}
      >
        {!errored && src && (
          <img
            src={src}
            alt={alt || ''}
            onError={() => setErrored(true)}
            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
          />
        )}
        {errored && (
          <div
            style={{
              width: '100%',
              height: '100%',
              background: 'repeating-linear-gradient(135deg, var(--paper-3) 0 14px, var(--paper-2) 14px 28px)'
            }}
          />
        )}
      </div>

      {label && <span className="ph-label" style={{ zIndex: 2 }}>{label}</span>}
    </div>
  );
};

/* ---------- Photo in rectangular card with brush accents ---------- */
export const FramedPhoto = ({ src, alt, label, height, brush, style, children }) =>
  <div className="relative" style={{ height, ...style }}>
    {brush && (
      <BrushBlob
        color={brush}
        style={{
          position: 'absolute',
          width: '60%',
          height: '60%',
          top: '-12%',
          right: '-10%',
          opacity: 0.85,
          zIndex: 0,
          transform: 'rotate(-8deg)'
        }}
      />
    )}
    <div
      className="card ph"
      style={{
        position: 'relative',
        zIndex: 1,
        height: '100%',
        overflow: 'hidden',
        borderRadius: 24
      }}
    >
      {src ? (
        <img
          src={src}
          alt={alt || ''}
          style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
          onError={(e) => {
            e.currentTarget.style.display = 'none';
          }}
        />
      ) : null}
      {label && <span className="ph-label">{label}</span>}
      {children}
    </div>
  </div>;
